import type { GetIsLabGrownFragment } from '@/graphql/api'

export function isSuffixLabGrown(item: GetIsLabGrownFragment): item is Exclude<
    GetIsLabGrownFragment,
    'suffix'
> & {
    suffix: 'lab grown'
} {
    return item.suffix === 'lab grown'
}
